// extracted by mini-css-extract-plugin
module.exports = {"mobileCenter":"style_mobileCenter__pbiFi","separator":"style_separator__HbMVr","separatorGreyUnderline":"style_separatorGreyUnderline__6X16h"};